






































import AudioGroupViewModel from "@models/meditations/create/audioGroupViewModel";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class AudioGroupBlockComponent extends Vue {
  @Prop({ type: Object }) audioGroup: AudioGroupViewModel;
  @Prop({ type: Boolean, default: false }) showDescription: boolean;
  startEdit() {
    this.$emit("edit", this.audioGroup);
  }
  startDelete() {
    this.$emit("delete", this.audioGroup);
  }
}
